import { observer } from "mobx-react-lite";
import * as React from "react";
import { AnchorItem, EntityAnchor } from "src/components/EntityAnchor";

import { MfNode, RenderCtx } from "../../node/MfNode";
import { ZMfNodeVertNav } from "../../ZMfNode";
import { groupBlockId } from "../MfGroupBlockView/groupBlockId";
import * as styles from "./MfVertNavLayout.module.less";

type PropsMfVertNavLayout = {
  items: MfNode[];
  meta: ZMfNodeVertNav;
  ctx: RenderCtx;
};

const containerSelector = "MfVertNavLayout";

export const MfVertNavLayout: React.FC<PropsMfVertNavLayout> = observer(
  (props) => {
    const { items, meta, ctx } = props;
    const anchorItems: AnchorItem[] = items
      .map(({ meta: itemMeta, key }) => {
        if (itemMeta.type === "group") {
          return {
            key,
            title: itemMeta.title,
            href: `#${groupBlockId(itemMeta)}`,
          };
        }
        return null;
      })
      .filter((it) => !!it);
    return (
      <div className={styles.box}>
        {meta.useNavBar && (
          <div className={styles.nav}>
            <EntityAnchor
              anchors={anchorItems}
              containerSelector={`#${containerSelector}`}
            />
          </div>
        )}
        <div className={styles.main} id={containerSelector}>
          <div className={styles.content}>
            {items.map(({ Render, key }) => (
              <Render key={key} ctx={ctx} />
            ))}
          </div>
        </div>
      </div>
    );
  },
);
